<template>
  <div>
    <row>
      <Upload
        :name="name"
        :action="action"
        :multiple="multiple"
        :format="format"
        :before-upload="handleBeforeUpload"
        :data="getTokenData"
        :show-upload-list="false"
        :on-success="handleSuccess"
        :on-progress="handleProgress"
        :on-error="handleError"
        :on-remove="handleRemove"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleSizeError"
        :headers="{ Authorization: token }"
        v-if="type == 'document' || type == 'documentAll'"
      >
        <Col span="4">
          <Button
            :style="Style == 'width' ? 'width:350px' : null"
            icon="ios-cloud-upload-outline"
            >上传文件</Button
          >
        </Col>
      </Upload>
    </row>
    <Row v-for="(item, index) in list" :key="index" style="margin-top: 10px">
      <Col span="18">
        <Input
          type="text"
          :value="item.name"
          v-model="item.name"
          placeholder="输入文件名称"
          @on-change="onChangeFileName"
        ></Input>
      </Col>
      <Col span="4" offset="1">
        <Button @click="delImage(index)">删除</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import * as qiniu from "qiniu-js";
import axios from "axios";
import config from "@/../config";

// 配置
axios.defaults.baseURL = config.API_HOST;
// axios.defaults.withCredentials = true
axios.defaults.headers.post["Content-Type"] = "application/json";
export default {
  name: "uploadFile2",
  props: {
    name: String,
    value: String,
    type: String,
    uploadType: {
      type: String,
      default: () => "Local",
    },
    multiple: {
      type: Boolean,
      default: () => false,
    },
    Style: String,
  },
  data() {
    return {
      list: [],
      token: window.localStorage.getItem("token") || "",
      action: "",
      actionQiniu: "http://upload.qiniup.com",
      actionOss: "http://oss-cn-hangzhou.aliyuncs.com",
      isUploading: false,
      uploading_rate: 0,
      showMaster: true,
      weburl: "",
      format: ["jpg", "jpeg", "png", "doc", "docx", "xlsx", "xls", "bin"],
      gallery: [],
      block: false,
    };
  },
  computed: {},
  watch: {
    value(v) {
      if (this.multiple) {
        if (v) {
          let arr = v.split(",");
          this.list = [];
          for (let index = 0; index < arr.length; index++) {
            const element = arr[index].split("#") || [];
            let dd = {};
            let cc = {};
            dd.name = element[1];
            cc.url = element[0];
            dd.response = cc;
            this.list.push(dd);
          }
          this.gallery = v.split(",");
        } else {
          this.gallery = [];
        }
        return true;
      }
      // 设置网络地址
      this.weburl = v;
      this.showMaster = false;
    },
  },
  async created() {
    /* if (this.Style == "width") {
      this.block = true;
    } */
    if (this.type == "image") {
      this.action = config.API_HOST + "/admin/common/upload";
      this.format = ["jpg", "gif", "png", "jpeg"];
    } else if (this.type == "avatar") {
      this.action = config.API_HOST + "/admin/common/upload";
      this.format = ["jpg", "gif", "png", "jpeg"];
    } else if (this.type == "audio") {
      this.action = config.API_HOST + "/admin/common/upload";
      this.format = ["mp3", "aac", "m4a", "wav", "flac"];
    } else if (this.type == "video") {
      this.action = config.API_HOST + "/admin/common/upload";
      this.format = ["mp4", "avi", "mov"];
    } else if (this.type == "document") {
      this.action = config.API_HOST + "/admin/common/upload";
      this.format = [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "pdf",
        "txt",
        "wps",
      ];
    } else if (this.type == "documentAll") {
      this.action = config.API_HOST + "/admin/common/upload";
      this.format = [
        "bmp",
        "gif",
        "jpg",
        "jpeg",
        "png",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "html",
        "htm",
        "txt",
        "rar",
        "zip",
        "gz",
        "bz2",
        "mp4",
        "avi",
        "rmvb",
        "mp3",
        "mpeg",
        "audio",
        "audio/mpeg",
        "pdf",
      ];
    } else if (this.type == "design") {
      this.action = config.API_HOST + "/admin/common/upload";
      this.format = [
        "jpg",
        "gif",
        "png",
        "jpeg",
        "bmp",
        "psd",
        "cdr",
        "zip",
        "pdf",
        "is",
        "so",
        "eps",
        "ai",
        "pcd",
        "raw",
      ];
    } else {
      this.action = config.API_HOST + "/admin/common/upload";
      this.format = [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "pdf",
        "txt",
        "wps",
        "bin",
      ];
    }
  },
  mounted() {
    if (this.multiple) {
      if (this.value) {
        this.gallery = this.value.split(",");
      } else {
        this.gallery = [];
      }
    } else {
      if (this.value) {
        // 设置网络地址
        this.weburl = this.value;
        this.showMaster = false;
      }
    }
  },
  methods: {
    // 获取上传Token
    async getTokenData() {
      if (this.uploadType == "Local") {
        return {};
      }
      let q = {};
      q.upload_type = this.uploadType;
      let res = await $utils.api.load("uploadToken", q);
      if (res && res.data) {
        this.token = res.data.upload_token;
        this.domain = res.data.upload_domain;
      }
      return { token: this.token, domain: this.domain };
    },
    setimage(src) {
      if (src) {
        return $utils.image.load(src);
      }
    },
    showMasterBox() {
      this.showMaster = true;
    },
    hideMasterBox() {
      if (this.value) {
        this.showMaster = false;
      } else {
        this.showMaster = true;
      }
    },
    showMasterDelBox() {
      this.showMasterDel = true;
    },
    hideMasterDelBox() {
      this.showMasterDel = false;
    },
    delImage(value) {
      this.gallery.splice(value, 1);
      this.list.splice(value, 1);
      this.emitInput();
    },
    async handleBeforeUpload(file) {
      this.file = file;
      this.isUploading = true;
      this.uploading_rate = 0;
      if (this.uploadType == "Local") {
        return true;
      }
      // 其他上传方式
      if (this.uploadType == "Qiniu") {
        let tokenConfig = await this.getTokenData();
        let token = tokenConfig.token;
        let domain = tokenConfig.domain;
        if (!token) {
          // 返回本地上传
          return true;
        }
        this.action = "";
        let ext = file.name.substring(file.name.lastIndexOf("."));
        let fileName =
          Date.parse(new Date()) + (file.lastModified || file.size);
        let key =
          "upload/xiaoju/" +
          $utils.time.format(Date.parse(new Date()) / 1000, "YYYY-MM-DD") +
          "/" +
          fileName +
          ext;
        let observable = qiniu.upload(file, key, token, {}, {});
        // 开始上传
        this.subscription = observable.subscribe(
          (next) => {
            this.isUploading = true;
            this.uploading_rate = parseFloat(next.total.percent).toFixed(2);
          },
          (error) => {
            this.isUploading = false;
            this.uploading_rate = 0;
            console.log("upload subscribe error", error);
            $utils.toast.error(error.msg + ":" + error.code);
          },
          (complete) => {
            this.isUploading = false;
            this.uploading_rate = 100;
            let url = domain + "/" + complete.key;
            this.value = url;
            let xxx = url;
            if (this.multiple) {
              this.gallery.push(this.value);
              xxx = this.gallery.join(",");
            }
            this.$emit("input", xxx);
          }
        );
        // subscription.unsubscribe() // 上传取消
        return false;
      }
      return true;
    },
    handleProgress(res, file, filelist) {
      if (this.uploadType == "Qiniu" || this.uploadType == "Oss") {
        return true;
      }
      this.isUploading = true;
      this.uploading_rate = parseFloat(res.percent).toFixed(2);
    },
    handleSuccess(res, file, filelist) {
      this.isUploading = false;
      this.uploading_rate = parseFloat(res.percentage).toFixed(2);
      if (this.uploadType == "Qiniu" || this.uploadType == "Oss") {
        return true;
      }
      $utils.toast.text(res.msg);
      let src = (res.data && res.data.url && res.url) || "";
      this.value = res.url;
      let xxx = res.url;
      this.list.push(file);
      this.emitInput();
    },
    handleError(error, file, filelist) {
      if (this.uploadType == "Qiniu" || this.uploadType == "Oss") {
        return true;
      }
      this.isUploading = false;
      this.uploading_rate = 0;
      $utils.toast.error("上传错误");
    },
    handleRemove(file, filelist) {
      this.isUploading = false;
      this.uploading_rate = 0;
    },
    onChangeFileName() {
      this.emitInput();
    },
    emitInput() {
      let arr = [];
      for (let index = 0; index < this.list.length; index++) {
        const keys =
          this.list[index] &&
          this.list[index].response &&
          this.list[index].response.url;
        const val = this.list[index].name;
        let str = keys + "#" + val;
        arr.push(str);
      }
      this.$emit("input", arr.join(","));
    },
    handleFormatError(file, filelist) {
      this.isUploading = false;
      this.uploading_rate = 0;
      $utils.toast.error("上传格式错误");
    },
    handleSizeError(file, filelist) {
      this.isUploading = false;
      this.uploading_rate = 0;
      $utils.toast.error("上传大小超限");
    },
    inputChange(e) {
      this.value = this.weburl;
      this.$emit("input", this.weburl);
    },
  },
};
</script>
<style lang="less" scoped>
.upload_box {
  position: relative;
  display: flex;
  width: 200px;
  height: 112px;
  text-align: center;
  margin-right: 10px;
  border: 1px dashed #dddee1;
  border-radius: 0px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  &:hover {
    border-color: #2d8cf0;
  }
}

.upload_master {
  position: absolute;
  width: 100%;
  height: 110px;
  border: none;
  border-radius: 0px;
  background: rgba(255, 255, 255, 1);
  top: 0;
  bottom: 0;
  color: #333;
  &:hover {
    color: #fff;
    background: rgba(0, 0, 0, 0.4);
  }
}

.upload_box_del {
  position: relative;
  display: flex;
  width: 100px;
  height: 112px;
  text-align: center;
  margin-right: 10px;
  border: 1px dashed #dddee1;
  border-radius: 0px;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  float: left;
  margin-top: 5px;
  &:hover {
    border-color: #2d8cf0;
  }
}

.upload_master_del {
  position: absolute;
  width: 100%;
  height: 110px;
  border: none;
  border-radius: 0px;
  background: rgba(255, 255, 255, 1);
  top: 0;
  bottom: 0;
  color: #333;
  &:hover {
    color: #fff;
    background: rgba(0, 0, 0, 0.4);
  }
}

.upload_rate {
  position: absolute;
  width: 100%;
  height: 110px;
  border: none;
  border-radius: 0px;
  background: #fff;
  top: 0;
  bottom: 0;
  color: #333;
  &:hover {
    color: #fff;
    background: rgba(0, 0, 0, 0.4);
  }
}

.upload_img {
  width: 90%;
  border-radius: 0px;
  overflow: hidden;
  height: auto;
}
</style>
